import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { catchError } from 'rxjs/operators';
import DOMPurify from 'dompurify';

@Component({
    selector: 'lib-svg-icon',
    templateUrl: './svg-icon.component.html',
    styleUrls: ['./svg-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SvgIconComponent implements OnInit {
  @Input() public url: string;
  @Input() public size = 24;

  @Output() loadFailed: EventEmitter<void> = new EventEmitter();

  public svgIcon: SafeHtml;

  constructor(
    private readonly cdf: ChangeDetectorRef,
    private readonly httpClient: HttpClient,
    private readonly sanitizer: DomSanitizer,
    ) {
  }

  ngOnInit(): void {
    this.httpClient.get(this.url, { responseType: 'text' }) 
      .pipe(
        catchError(error => {
          this.loadFailed.emit();
          throw error;
        })
      )
      .subscribe(value => {
        const safeSvg = DOMPurify.sanitize(value, { USE_PROFILES: { svg: true } });
        this.svgIcon = this.sanitizer.bypassSecurityTrustHtml(safeSvg);
        this.cdf.markForCheck();
      });
  }
}
